import AppHeader from '../app/appHeader';
import React, { FC, useEffect, useState } from 'react';
import './styles/declinedRegistration.scss';
import { Link, Typography } from '@getgo/chameleon-web/react';
import Footer from '../footer/footer';
import { useTranslation } from 'react-i18next';
import { useEventContext } from '../context/eventContext';
import { useParams } from 'react-router';
import { IEventUrlParameters } from '../event/eventInterface';
import API from '../utils/api';
import FullScreenLoader from '../utils/fullScreenLoader/FullScreenLoader';
import MailToUtils from '../../utils/MailToUtils';

const DeclinedRegistration: FC = () => {
  const { t, i18n } = useTranslation();
  const [isLoading, setLoading] = useState<boolean>(true);
  const { eventId } = useParams<IEventUrlParameters>();
  const { setEventDetails, eventDetails } = useEventContext();

  useEffect(() => {
    if (!eventDetails) {
      const getEvent = async () => {
        const eventData = await API.getEventDetails(eventId || '');
        const lang = eventData?.data?.locale?.substr(0, 2).toLowerCase() || 'en';
        if (lang && lang !== i18n.language) {
          i18n.changeLanguage(lang, () => {
            let langCopy = lang;
            if (langCopy === 'zh') {
              langCopy = 'zh-cn';
            }
            // TO-DO Change language for date
            document.documentElement.lang = langCopy;
          });
        }
        if (eventData.status === 200) {
          setEventDetails(eventData.data);
        }
      };
      getEvent();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eventDetails]);

  useEffect(() => {
    if (eventDetails?.locale.includes(i18n.language)) {
      setLoading(false);
    }
  }, [eventDetails?.locale, i18n.language]);

  return isLoading ? (
    <FullScreenLoader />
  ) : (
    <div className="declined-registration-grid">
      <AppHeader />
      <div className="declined-registration">
        <div className="box">
          <div className="box-space">
            <div>
              <Typography color="text-01" variant="heading-large">
                {t('declinedRegistration.title')}
              </Typography>
            </div>
            <div className="declined-registration-description">
              <p>
                <Typography color="text-01" variant="body-large">
                  {t('declinedRegistration.subTitle')} {eventDetails?.title}
                </Typography>
              </p>
              <p>
                <Typography color="text-01" variant="body-large">
                  {t('declinedRegistration.description')}
                </Typography>
              </p>
              <p>
                <Typography color="text-01" variant="body-large">
                  <Link href={MailToUtils.createLink(eventDetails?.organizers?.[0]?.email ?? '')}>
                    {eventDetails && eventDetails.organizers[0]?.email}
                  </Link>
                </Typography>
              </p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default DeclinedRegistration;
